import { cx } from '@vizit/theme';
import { STATUS_BADGE, type StatusBadgeStatus } from './types';

interface StatusBadgeProps {
  status: StatusBadgeStatus;
  className?: string;
}

function StatusBadge({ status, className }: StatusBadgeProps) {
  const { label, className: variantClassName } = STATUS_BADGE[status];

  return (
    <div
      className={cx(
        'inline-flex items-center justify-center px-4 py-1 font-medium text-sm',
        variantClassName,
        className,
      )}
      data-testid={`status-badge-${status}`}
    >
      {label}
    </div>
  );
}

export { StatusBadge };
export type { StatusBadgeProps };
